import React, { FunctionComponent } from "react";

const BinIcon: FunctionComponent = () => {
  // Custom: created by Sam Hankins
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <path
        fill="currentColor"
        d="M16.3125 14.0625H8.4375L3.9375 17.4375V14.0625H1.6875C1.0875 14.0625 0.5625 13.5375 0.5625 12.9375V1.6875C0.5625 1.0875 1.0875 0.5625 1.6875 0.5625H16.3125C16.9125 0.5625 17.4375 1.0875 17.4375 1.6875V12.9375C17.4375 13.5375 16.9125 14.0625 16.3125 14.0625Z"
      />
      <path
        d="M6.01196 4.2644L11.914 10.1665"
        stroke="white"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.913 4.3836L6.01093 10.2857"
        stroke="white"
        strokeWidth="1.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BinIcon;
